import React, { useContext } from 'react';
import { RadioGroupField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import styles from './RPSTRACRolloverOptions.css';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';

const RPSTRACRolloverOptions = ({ setRolloverOptionsNotice }) => {
  const { formProps } = useContext(FlowContext);

  const handleRolloverOptionsNotice = ({ target: { value } }) => {
    setRolloverOptionsNotice(value);
  };

  const radioOptions = [
    {
      title: 'Yes',
      value: 'YES'
    },
    {
      title: 'No',
      value: 'NO'
    }
  ];

  return (
    <div>
      <div className="section-header">
        <SectionHeading text="Rollover Options Notice" />
      </div>
      <div className="section-content">
        <div className="distribution-option-input">
          <RadioGroupField
            title="Upon separating from your former employer, did you receive a plan Distribution form which includes the Rollover Options Notice or 
                have you read the Rollover Options Notice on the T. Rowe Price website?"
            options={radioOptions}
            onChange={handleRolloverOptionsNotice}
            {...formProps.rolloverOptionsNotice}
            name="rolloverOptionsNotice"
          />
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default RPSTRACRolloverOptions;
